import { useCallback } from 'react';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LOGIN_PATH } from '../../api/paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AuthFailed() {
  const handleTryAgain = useCallback(() => {
    const loginUrl = new URL(LOGIN_PATH, window.location.origin);
    loginUrl.searchParams.set('redirect_url', window.location.href);
    window.location.href = loginUrl.toString();
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "AUTH_FAILED",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100dvh",
      padding: "800",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "start",
        gap: "500",
        maxInlineSize: "500px",
        backgroundColor: "fill-surface-default",
        borderRadius: "300",
        boxShadow: "100",
        padding: "800",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.authFailedHeading"
          })
        }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Text, {
          as: "p",
          typography: "body-200",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.authFailedBody"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleTryAgain,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.tryAgain"
          })
        })]
      })
    })
  });
}